import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { isRegistrationNumberValid } from "../helpers";
import { useIntl } from "react-intl";
import { messages } from "../messages";
import { CircularProgress, Button } from "@material-ui/core";
export const GetContractButton = ({ onGetContract, contractIsLoading, onResetForm }) => {
    const intl = useIntl();
    const { values, isSubmitting, setFieldValue, setFieldTouched } = useFormikContext();
    const registrationNumberIsValid = isRegistrationNumberValid(values.registrationNumber);
    const handleClick = () => {
        if (!registrationNumberIsValid) {
            setFieldTouched("registrationNumber", true);
            return;
        }
        if (onResetForm) {
            onResetForm();
        }
        setFieldValue("buyoutDate", "");
        setFieldValue("mileage", undefined);
        onGetContract(values.registrationNumber.trim());
    };
    return (_jsx(Button, { variant: "contained", color: "secondary", size: "large", fullWidth: true, onClick: handleClick, disabled: contractIsLoading || isSubmitting || !registrationNumberIsValid, children: contractIsLoading ? (_jsx(CircularProgress, { size: 20 })) : (intl.formatMessage(messages.getContract)) }));
};
//# sourceMappingURL=GetContractButton.js.map